import { emailPreviewUrl } from 'automation-ui-action-fields/automated-emails/emailUrlUtils';
import { registerQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import http from 'hub-http/clients/apiClient';
const emailPreviewFieldName = 'actionFields_emailPreview';
export const getEmailPreviewByteString = data => get(data, [emailPreviewFieldName, 'screenshots', 0, 'bytes']);
export const GET_EMAIL_PREVIEW = registerQuery({
  fieldName: emailPreviewFieldName,
  args: ['emailId', 'previewKey'],
  fetcher({
    emailId,
    previewKey
  }) {
    return http.post('hubshot/v3/screenshots/bytes', {
      data: {
        targetUrl: emailPreviewUrl(emailId, previewKey)
      }
    });
  }
});
const automatedEmailsByIdsFieldName = 'actionFields_automatedEmailsByIds';
export const getAutomatedEmails = data => get(data, automatedEmailsByIdsFieldName);
export const GET_AUTOMATED_EMAILS_BY_IDS = registerQuery({
  fieldName: automatedEmailsByIdsFieldName,
  args: ['emailId', 'sourceApp'],
  fetcher({
    emailId,
    sourceApp
  }) {
    return http.get('cosemail/v1/emails/search/automated-with-ticket-and-deal/multi', {
      query: {
        emailId,
        sourceApp
      }
    });
  }
});
const automatedEmailFieldName = 'automatedEmail';

/**
 * @deprecated Prefer using getAutomatedEmails with GET_AUTOMATED_EMAILS_BY_IDS.
 */
export const getAutomatedEmail = data => get(data, automatedEmailFieldName);

/**
 * @deprecated While this supports fetching multiple email IDs, it will only
 *   ever return the first object. Prefer GET_AUTOMATED_EMAILS_BY_IDS.
 */
export const GET_AUTOMATED_EMAIL = registerQuery({
  fieldName: automatedEmailFieldName,
  args: ['emailId', 'sourceApp'],
  fetcher({
    emailId,
    sourceApp
  }) {
    return http.get('cosemail/v1/emails/search/automated-with-ticket-and-deal/multi', {
      query: {
        emailId,
        sourceApp
      }
    }).then(response => {
      const [automatedEmail] = response;
      return automatedEmail;
    });
  }
});